<template lang="pug">
  .is-flex.is-flex-direction-column.is-align-items-stretch(style="width: 100%")
    .p-2.is-flex-shrink-0.days(style="overflow: auto")
      .day-slot.has-text-centered.px-1.py-3.mx-2.is-clickable(v-for="day in days" :key="day.value" @click="selectDay(day.value)" :class="[currentDate === day.value ? 'selected':'',!slotsByDay[day.value] || !slotsByDay[day.value].hours.length?'inactive':'' ]") 
        p.subtitle.is-7.is-marginless {{day.weekday}}
        p.title.is-5.is-marginless {{day.day}}
    .is-flex-grow-1.p-4(style="overflow: auto")
      div(v-if="currentDate && slotsByDay[currentDate].hours.length")
        
        h4.heading.mb-3 
          b
            date-view(:value="currentDate" format="LL")
        h3.title.is-6.mb-3(v-if="slotsByDay[currentDate].morning.length" v-t="'appointment.day_part.morning'")
        .columns.is-multiline.is-mobile
          .column.is-4.py-2(v-for="slot in slotsByDay[currentDate].morning") 
            .time-slot(@click="selectTime(slot)" :class="[selected === slot ? 'selected': '', slot.recommended? 'recommended': '']")
              .py-2 {{formatSlotLabel(slot)}}
        
        h3.title.is-6.mb-3(v-if="slotsByDay[currentDate].day.length" v-t="'appointment.day_part.day'")
        .columns.is-multiline.is-mobile
          .column.is-4.py-2(v-for="slot in slotsByDay[currentDate].day") 
            .time-slot(@click="selectTime(slot)" :class="[selected === slot ? 'selected': '', slot.recommended? 'recommended': '']")
              .py-2 {{formatSlotLabel(slot)}}
        
        h3.title.is-6.mb-3(v-if="slotsByDay[currentDate].evening.length" v-t="'appointment.day_part.evening'")
        .columns.is-multiline.is-mobile
          .column.is-4.py-2(v-for="slot in slotsByDay[currentDate].evening") 
            .time-slot(@click="selectTime(slot)" :class="[selected === slot ? 'selected': '', slot.recommended? 'recommended': '']")
              .py-2 {{formatSlotLabel(slot)}}

        
      .p-4.has-text-centered(v-else)
        p.subtitle.is-5 {{$t('appointment.no_slots_available')}}
          br
          | {{$t('please_call')}}
        a.button(:href="`tel:${company.phone}`")
          span.icon
            i.mdi.mdi-phone
          span(v-t="'actions.call_now'")

      
</template>

<script>
import {mapState} from 'vuex'
import dayjs from 'dayjs'
import slotsHelper from '../../../shared/slots'

export default {
  props: {
    staffIds: {type: Array, default: undefined},
    services: {type: Array, required: true},
    potentialResources: {type: Array, default: undefined},
    occupiedSlots: {type: Object, default: undefined},
    rangesByDay: {type: Object, required: true},
    availableRanges: {type: Object, required: true},
    bookedResources: {type: Object, required: true},
    from: {type: Number, required: true},
    to: {type: Number, required: true}
  },
  data() {
    return {
      currentDate: undefined,
      selected: undefined,
      slotsByDay: {},
      days: []
    }
  },
  computed: {
    ...mapState('company', ['company']),
    hasOverride() {
      return this.services.reduce((res, s) => res || !!s.option.override, false)
    }
  },
  created() {
    this.initDays()
    this.generateSlots()
    this.initSlotsByDays()
  },
  methods: {
    generateSlots() {
      let slots = []
      for (let day in this.rangesByDay) {
        let resources = this.potentialResources.map(r => {
          return {resourceId: r, busySlots: this.bookedResources[r] && this.bookedResources[r][day]}
        })

        let daySlots = this.staffIds
          .map(staffId => {
            return slotsHelper.generateSlots({
              day,
              preferred: this.staffIds.length === 1,
              ranges: this.availableRanges[staffId][day],
              resources,
              services: this.services,
              staffId,
              occupiedSlots: this.occupiedSlots,
              timeFormat: this.company.timeFormat,
              intervalType: this.company.onlineBookingInterval,
              bookAtLeastHours: this.company.bookAtLeastHours
            })
          })
          .reduce((merged, slots) => {
            for (let slot of slots) {
              let existingSlot = merged.find(
                s =>
                  s.start.valueOf() === slot.start.valueOf() && s.duration === slot.duration && s.price === slot.price
              )
              if (!existingSlot) {
                merged.push(slot)
              } else {
                existingSlot.staff = existingSlot.staff.concat(slot.staff)
              }
            }
            return merged
          }, [])
          .sort((a, b) => a.start - b.start)
        slots = slots.concat(daySlots)
      }
      this.slots = slots
    },
    initSlotsByDays() {
      this.slotsByDay = {}
      let selectedDay
      let selectedSlot

      for (let slot of this.slots) {
        let time = dayjs(slot.start)
        let day = time.format('YYYYMMDD')
        slot.day = parseInt(day)
        this.slotsByDay[day] = this.slotsByDay[day] || {hours: [], morning: [], day: [], evening: []}
        this.slotsByDay[day].hours.push(slot)
        if (time.get('hours') < 12) {
          this.slotsByDay[day].morning.push(slot)
        } else if (time.get('hours') >= 12 && time.get('hours') < 18) {
          this.slotsByDay[day].day.push(slot)
        } else {
          this.slotsByDay[day].evening.push(slot)
        }
        if (slot.recommended) {
          selectedDay = day
          selectedSlot = slot
        }
      }
      if (selectedDay) {
        this.selectDay(selectedDay)
        this.selectTime(selectedSlot)
      } else if (!this.slotsByDay[this.currentDate]) {
        for (let day in this.slotsByDay) {
          if (this.slotsByDay[day]) {
            this.selectDay(day)
            break
          }
        }
      }
    },
    initDays() {
      this.days = []
      let day = dayjs(String(this.from), 'YYYYMMDD')
      let lastDay = dayjs(String(this.to), 'YYYYMMDD')
      while (day.isBefore(lastDay)) {
        this.days.push({
          month: day.format('MMMM'),
          weekday: this.$t(`appointment.weekday.${day.get('day')}`),
          day: day.format('D'),
          value: parseInt(day.format('YYYYMMDD')).toString()
        })
        // if (!this.currentDate && this.slotsByDay[parseInt(day.format('YYYYMMDD'))].length) {
        //   this.selectDay(parseInt(day.format('YYYYMMDD')))
        // }
        day = day.add(1, 'day')
      }
    },
    selectTime(slot) {
      this.selected = slot
      this.$emit('input', slot)
    },
    selectDay(day) {
      if (!this.slotsByDay[day]) {
        return
      }
      this.selectTime(undefined)
      this.currentDate = day
    },
    formatSlotLabel(slot) {
      const format = this.company.timeFormat === '12' ? 'h:mma' : 'H:mm'
      const start = dayjs(slot.start).format(format)
      const end = dayjs(slot.end).format(format)
      return `${start} - ${end}`
    }
  }
}
</script>
